import { useState } from "react";

const ForgotPassword = ({forgotPassHandler}) => {
    const [username, setName] = useState("");
    const [ok, setOk] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const onFormSubmit = async (event) => {
        event.preventDefault();
        if (!username.trim()) return;
        
        setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/users/forgot-pw/${username}`, {method: "POST"});
            if (response.ok) {
                setOk(true);
            }
        } catch (error) {
            console.error("Error sending reset email:", error);
        } finally {
            setSubmitted(true);
            setIsLoading(false);
        }
    }

    return (
        <div className="w-full space-y-6">
            {/* Header */}
            <div className="text-center">
                <h2 className="text-xl font-bold text-gray-800 mb-2">Reset Your Password</h2>
                <p className="text-sm text-gray-600">Enter your username or email to receive a password reset link</p>
            </div>

            {/* Back Button */}
            <button 
                onClick={() => forgotPassHandler(false)}
                className="flex items-center text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors duration-200"
            >
                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Back to Login
            </button>

            {/* Reset Form */}
            {!submitted ? (
                <form onSubmit={onFormSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Username or Email
                        </label>
                        <input 
                            type="text"
                            value={username}
                            placeholder="Enter your username or email"
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>
                    
                    <button 
                        type="submit"
                        disabled={isLoading || !username.trim()}
                        className="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 disabled:from-blue-300 disabled:to-blue-400 text-white font-semibold py-3 px-4 rounded-lg transition-all duration-200 transform hover:scale-105 disabled:scale-100 shadow-md flex items-center justify-center"
                    >
                        {isLoading ? (
                            <>
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Sending...
                            </>
                        ) : (
                            "Send Reset Link"
                        )}
                    </button>
                </form>
            ) : (
                /* Results Section */
                <div className="text-center space-y-4">
                    {ok ? (
                        <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 border border-green-200">
                            <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Email Sent Successfully!</h3>
                            <p className="text-gray-600 text-sm mb-4">
                                Check your email for a password reset link. The link will expire in 1 hour.
                            </p>
                            <button 
                                onClick={() => forgotPassHandler(false)}
                                className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-md"
                            >
                                Return to Login
                            </button>
                        </div>
                    ) : (
                        <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-xl p-6 border border-red-200">
                            <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">User Not Found</h3>
                            <p className="text-gray-600 text-sm mb-4">
                                No account found with that username or email address. Please check and try again.
                            </p>
                            <div className="flex gap-3 justify-center">
                                <button 
                                    onClick={() => { setSubmitted(false); setName(""); }}
                                    className="bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-md"
                                >
                                    Try Again
                                </button>
                                <button 
                                    onClick={() => forgotPassHandler(false)}
                                    className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-md"
                                >
                                    Back to Login
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {/* Help Text */}
            {!submitted && (
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                    <div className="flex items-start">
                        <svg className="w-5 h-5 text-blue-500 mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div>
                            <p className="text-sm text-blue-700 font-medium">Can't access your email?</p>
                            <p className="text-xs text-blue-600 mt-1">
                                Contact support at <span className="font-semibold">info@catchphraser.com</span> for assistance.
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ForgotPassword;